var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_metro-quote","data-name":"Icon metro-quote","d":"M8.355,17.352v7.712h7.712V17.352H12.211s0-3.856,3.856-3.856V9.64s-7.712,0-7.712,7.712ZM27.635,13.5V9.64s-7.712,0-7.712,7.712v7.712h7.712V17.352H23.779S23.779,13.5,27.635,13.5Z","transform":"translate(-8.355 -9.64)","fill":"#fade4b"}));
}

Quote.defaultProps = {"width":"19.28","height":"15.424","viewBox":"0 0 19.28 15.424"};

module.exports = Quote;

Quote.default = Quote;
